export enum QuestionTypeEnum {
  Unknown = 0,
  Other = 1,
  SingleChoice = 10,
  MultiChoice = 11,
  FreeText = 12,
  RankedChoice = 13,
}

export enum SurveyTemplateEnum {
  PowerGen = 2,
  BuildingPerformance = 4,
  BatteryStorage = 5,
  EvCharging = 6,
  CarbonEmissions = 7,
  DemandResponse = 8,
}

export type SurveyTemplateMode = "explore" | "onboarding";

export const SurveyCompletionMode = {
  OnboardingShort: "OnboardingShort",
  Comprehensive: "Comprehensive",
} as const;

export type SurveyCompletionModeValue =
  (typeof SurveyCompletionMode)[keyof typeof SurveyCompletionMode];

export const isComprehensiveCompletion = (
  mode: string | null | undefined
): boolean =>
  (mode || "").toLowerCase() ===
  SurveyCompletionMode.Comprehensive.toLowerCase();
